export default __webpack_public_path__ + "static/media/marker-declique.c3642200.png";